import React from 'react';
import {withStyles} from "@material-ui/core";
import Layout from '../../components/Layout';
import i18n from '../../i18n';
import ContactGrid from "../../components/Contacts/ContactGrid";
import Toolbar from "../../components/Toolbar/Toolbar";

const ContactsIndex = ({classes, contacts, contactType, house}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={ i18n.get('contacts.heading_' + contactType)}
            subtitle={`${contacts.length} ${i18n.get('contacts.number_of_' + contactType)}`}
            items={[
                {
                    icon: 'add',
                    text: i18n.get('contacts.new_' + contactType),
                    href: `/contacts/${contactType}s/create${house ? '?house=' + house.id : ''}`,
                }
            ]}
        />

        <ContactGrid contacts={contacts}/>
    </Layout>
);

const styles = theme => ({
    paper: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginTop: theme.spacing.unit * 6,
            marginBottom: theme.spacing.unit * 6,
            padding: theme.spacing.unit * 3,
        },
    },
});

export default withStyles(styles)(ContactsIndex);



// WEBPACK FOOTER //
// ./resources/assets/js/pages/contacts/Index.jsx